"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typography = _interopRequireDefault(require("../typography"));

var _button = _interopRequireDefault(require("../button"));

var _fi = require("react-icons/fi");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\nh2.typography-heading-04 {\n  margin: 0; }\n\np.typography-body-text {\n  margin: 0; }\n\n.dialog-container {\n  display: flex;\n  flex-direction: column;\n  border: 0.0625rem solid #6f6f6f;\n  box-sizing: border-box;\n  opacity: 1;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  min-width: 29rem;\n  min-height: 17.375rem;\n  background-color: #ffffff;\n  z-index: 40; }\n  .dialog-container .popup-strap {\n    min-height: 0.5rem;\n    min-width: 28.875rem; }\n  .dialog-container .heading-container {\n    display: flex;\n    justify-content: space-between; }\n    .dialog-container .heading-container .title-container {\n      margin-left: 2rem;\n      margin-top: 2rem;\n      margin-bottom: 1rem;\n      color: #393939; }\n    .dialog-container .heading-container .icon-container {\n      margin-right: 2rem;\n      margin-top: 2.4375rem;\n      margin-bottom: 1.5rem;\n      height: 1.5rem; }\n  .dialog-container .message-container {\n    display: flex;\n    margin: 0rem 2rem 2rem 2rem;\n    color: #393939;\n    overflow-y: hidden;\n    flex-grow: 2; }\n  .dialog-container .message-container:hover {\n    overflow-y: auto; }\n  .dialog-container .message-container::-webkit-scrollbar {\n    width: 0.5rem; }\n  .dialog-container .message-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .dialog-container .message-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .dialog-container .message-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n  .dialog-container .button-container {\n    display: flex;\n    justify-content: flex-end;\n    margin-right: 2rem;\n    margin-bottom: 2rem; }\n    .dialog-container .button-container .button-wrapper:last-child:not(:first-of-type) {\n      margin-left: 1rem; }\n  .dialog-container .dialog-children-wrapper {\n    margin: 0 2rem 2rem 2rem; }\n\n.overlay-container {\n  position: fixed;\n  background-color: #161616;\n  opacity: 0.3;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 30; }\n";
  var fileName = "compone_dialog";
  var element = document.querySelector("style[data-sass-component='compone_dialog']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var DialogPopup = function DialogPopup(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? _constants.dialogType.general : _ref$type,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? _constants.defaultWidth : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? _constants.defaultHeight : _ref$height,
      title = _ref.title,
      message = _ref.message,
      primaryButtonText = _ref.primaryButtonText,
      secondaryButtonText = _ref.secondaryButtonText,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      children = _ref.children,
      _ref$primaryButtonDis = _ref.primaryButtonDisabled,
      primaryButtonDisabled = _ref$primaryButtonDis === void 0 ? false : _ref$primaryButtonDis;

  var _useState = (0, _react.useState)(document.createElement('div')),
      _useState2 = _slicedToArray(_useState, 1),
      dialogEl = _useState2[0];

  dialogEl.id = 'dialog-popup';
  dialogEl.style.position = 'fixed';
  dialogEl.style.zIndex = _constants.zIndex;
  (0, _react.useEffect)(function () {
    var bodyElement = document.getElementsByTagName('body')[0];
    bodyElement.appendChild(dialogEl);
    return function () {
      return bodyElement.removeChild(dialogEl);
    };
  }, [dialogEl]);

  var getStrapColor = function getStrapColor() {
    switch (type) {
      case _constants.dialogType.general:
        return _constants.generalColor;

      case _constants.dialogType.alert:
        return _constants.alertColor;

      case _constants.dialogType.error:
        return _constants.errorColor;
    }
  };

  var getDialogStrap = function getDialogStrap() {
    return /*#__PURE__*/_react.default.createElement("div", {
      role: "popup-strap",
      className: _constants.classes.popupStrap,
      style: {
        width: width - 2,
        backgroundColor: getStrapColor()
      }
    });
  };

  var getDialogHeader = function getDialogHeader() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.headingContainer
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.titleContainer
    }, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "heading4"
    }, title)), /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.iconContainer
    }, /*#__PURE__*/_react.default.createElement(_fi.FiX, {
      color: _constants.iconColor,
      size: _constants.iconSize,
      onClick: onCancel,
      style: {
        cursor: 'pointer'
      }
    })));
  };

  var getDialogMessage = function getDialogMessage() {
    return /*#__PURE__*/_react.default.createElement("div", {
      role: "message",
      className: _constants.classes.messageContainer
    }, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "body"
    }, message));
  };

  var getChildrenContainer = function getChildrenContainer() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.dialogChildrenWrapper
    }, children);
  };

  var getDialogButton = function getDialogButton() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.buttonContainer
    }, secondaryButtonText && getActionButton('secondary', secondaryButtonText, onCancel), primaryButtonText && getActionButton('primary', primaryButtonText, onSubmit, primaryButtonDisabled));
  };

  var getActionButton = function getActionButton(type, buttonText, clickHandler, primaryButtonDisabled) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.buttonWrapper
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: type,
      size: "large",
      onClick: clickHandler,
      disabled: primaryButtonDisabled
    }, buttonText));
  };

  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.overlayContainer
  }), /*#__PURE__*/_react.default.createElement("div", {
    role: "dialog-popup",
    className: _constants.classes.dialogContainer,
    style: {
      width: width,
      height: height
    }
  }, getDialogStrap(), getDialogHeader(), message && getDialogMessage(), children && getChildrenContainer(), (primaryButtonText || secondaryButtonText) && getDialogButton())), dialogEl);
};

DialogPopup.propTypes = {
  type: _propTypes.default.oneOf([_constants.dialogType.general, _constants.dialogType.alert, _constants.dialogType.error]),
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  title: _propTypes.default.string.isRequired,
  message: _propTypes.default.string,
  primaryButtonText: _propTypes.default.string,
  secondaryButtonText: _propTypes.default.string,
  onSubmit: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  children: _propTypes.default.oneOfType([_propTypes.default.elementType, _propTypes.default.func]),
  primaryButtonDisabled: _propTypes.default.bool
};
var _default = DialogPopup;
exports.default = _default;